import ChipInput from 'material-ui-chip-input';

import CloseIcon from '~/images/Icons/Glyphs/CloseIcon.svg';

const styles = () => ({
  root: {
    margin: '8px 0 6px 0',
  },

  chipContainer: {
    minHeight: 36,
    marginBottom: 0,
  },

  inputRoot: {
    padding: '0 8px 0 8px',
    display: 'flex',
    flexWrap: 'wrap',
    boxShadow:
      'inset 0px 0px 0px 1px rgb(225, 233, 240), inset 0px 3px 1px 0px rgba(225, 233, 240, 0.15), inset 0px 0px 1px 1px rgba(155, 173, 188, 0.15)',
    borderRadius: 6,
  },

  helperText: {
    margin: '8px 0 8px 0',
  },

  input: {
    padding: 0,
    height: '36px',
    color: '#414953',
    flex: '1 1 100px',

    '& *::before': {
      backgroundColor: '#eff0f0',
      height: '1px !important',
    },
    '& *:hover::before': {
      height: '2px !important',
      backgroundColor: '#E1E9F0 !important',
    },
  },

  label: {
    paddingBottom: 16,
  },

  labelShrink: {
    transform: 'none',
  },

  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    height: 24,
    borderRadius: 4,
    backgroundColor: '#dbf1fe',
    padding: '0 6px 0 6px',
    margin: '5px 8px 5px 0',
    fontSize: 14,
    color: '#27282a',
  },

  deleteIcon: {
    marginLeft: 4,
    cursor: 'pointer',
  },
});

function ChipInputWrapper({
  classes,
  rootClassName,
  inputRootClass,
  ...props
}) {
  const { deleteIcon: deleteIconClassName, ...restOfClasses } = classes;

  const propClasses = {
    ...restOfClasses,
    ...(!!rootClassName && {
      root: classnames(classes.root, inputRootClass),
    }),
    ...(!!inputRootClass && {
      inputRoot: classnames(classes.inputRoot, inputRootClass),
    }),
  };

  return (
    <ChipInput
      {...props}
      classes={propClasses}
      InputLabelProps={{ shrink: true }}
      fullWidthInput={props.fullWidth}
      deleteIcon={<CloseIcon />}
      chipRenderer={(
        { value, text, handleClick, handleDelete, className },
        index,
      ) => (
        <div
          key={index}
          className={className}
          onClick={() => handleClick(value)}>
          {text}
          <CloseIcon
            className={deleteIconClassName}
            onClick={() => handleDelete(value)}
          />
        </div>
      )}
      variant="base"
    />
  );
}

ChipInputWrapper.propTypes = {
  fullWidth: PropTypes.bool,
};

export default withStyles(styles)(ChipInputWrapper);
